"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEventCompetitorsRenameSelector = exports.makeSelectEventProbabilityByMarketFilteredV3 = exports.makeSelectEventProbabilityByMarketFiltered = exports.selectEventProbabilityByMarketFiltered = exports.selectEventProbabilityByMarket = exports.selecteventProbabilitiesByMarket = exports.selectEventProbabilitiesByVirtualMarketByEvent = exports.selectEventProbabilitiesByVirtualMarketEntries = exports.selectEventCompetitors = exports.selectEventDate = exports.selectEventStatus = exports.selectEventTypeCode = exports.selectEventHomeCompetitorIds = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const events_1 = require("../../../utils/events");
const array_1 = require("../../../utils/array");
const outcomes_1 = require("../../../utils/outcomes");
const selectors_1 = require("../../ConfigProvider/selectors");
const eventsSelectors_1 = require("./eventsSelectors");
const selectEventCompetitorsList = (state, eventId) => {
    var _a;
    return (((_a = state.eventsProvider.events.entries[eventId]) === null || _a === void 0 ? void 0 : _a.competitors) || array_1.EMPTY_ARRAY);
};
const selectEventHomeCompetitorIds = (state, eventId) => {
    var _a;
    return (_a = state.eventsProvider.events.entries[eventId]) === null || _a === void 0 ? void 0 : _a.homeCompetitorIds;
};
exports.selectEventHomeCompetitorIds = selectEventHomeCompetitorIds;
const selectEventTypeCode = (state, eventId) => {
    return (0, eventsSelectors_1.selectEventById)(state, eventId).eventType;
};
exports.selectEventTypeCode = selectEventTypeCode;
const selectEventStatus = (state, eventId) => {
    return (0, eventsSelectors_1.selectEventById)(state, eventId).status;
};
exports.selectEventStatus = selectEventStatus;
const selectEventDate = (state, eventId) => {
    return (0, eventsSelectors_1.selectEventById)(state, eventId).eventDate;
};
exports.selectEventDate = selectEventDate;
exports.selectEventCompetitors = (0, toolkit_1.createSelector)([selectEventCompetitorsList, exports.selectEventHomeCompetitorIds], (eventCompetitors, eventHomeCompetitorIds) => (0, events_1.getHomeAwayCompetitors)(eventCompetitors, eventHomeCompetitorIds));
const selectEventProbabilitiesByVirtualMarketEntries = (state) => {
    return state.eventsProvider.eventProbabilitiesByVirtualMarket.entries;
};
exports.selectEventProbabilitiesByVirtualMarketEntries = selectEventProbabilitiesByVirtualMarketEntries;
const selectEventProbabilitiesByVirtualMarketByEvent = (state, eventId) => {
    return (0, exports.selectEventProbabilitiesByVirtualMarketEntries)(state)[eventId];
};
exports.selectEventProbabilitiesByVirtualMarketByEvent = selectEventProbabilitiesByVirtualMarketByEvent;
const selecteventProbabilitiesByMarket = (state) => {
    return state.eventsProvider.eventProbabilitiesByMarket.entries;
};
exports.selecteventProbabilitiesByMarket = selecteventProbabilitiesByMarket;
const selectEventProbabilityByMarket = (state, eventId, marketId, categoryMarketInfoId) => {
    var _a;
    return state.eventsProvider.eventProbabilitiesByMarket.entries[eventId]
        ? ((_a = state.eventsProvider.eventProbabilitiesByMarket.entries[eventId][(0, outcomes_1.getEventProbabilityByMarketKey)({ marketId, categoryMarketInfoId })]) === null || _a === void 0 ? void 0 : _a.probabilities) || []
        : [];
};
exports.selectEventProbabilityByMarket = selectEventProbabilityByMarket;
const selectStatusFilterForEventProbabilityByMarket = (state, eventId, marketId, categoryMarketInfoId, tradingStatus) => tradingStatus;
/*
  Not optimized. Recreated each time with new params, i.e. in list of items

  For lists use makeSelectEventProbabilityByMarketFiltered
*/
exports.selectEventProbabilityByMarketFiltered = (0, toolkit_1.createSelector)([
    exports.selectEventProbabilityByMarket,
    selectStatusFilterForEventProbabilityByMarket,
], (eventProbabilityOutcomes, tradingStatus) => tradingStatus
    ? eventProbabilityOutcomes.filter((eventProbabilityOutcome) => eventProbabilityOutcome.tradingStatus === tradingStatus)
    : eventProbabilityOutcomes);
/*
  Optimized version of selectEventProbabilityByMarketFiltered

  Usage example:

  const outcomesSelector = makeSelectEventProbabilityByMarketFiltered()
  const outcomes = useSelector((state: RootState) =>
    outcomesSelector(
      state,
      eventId,
      categoryMarketInfo.marketId,
      categoryMarketInfo.id,
      isShowAllEventProbs ? undefined : EventProbabilityTradingStatus.Trading
    )
  )
*/
const EMPTY_PROBS_ARRAY = [];
const makeSelectEventProbabilityByMarketFiltered = () => {
    const selector = (0, toolkit_1.createSelector)([
        (state) => state.eventsProvider.eventProbabilitiesByMarket.entries,
        (_, eventId) => eventId,
        (_, __, marketId) => marketId,
        (_, __, ___, catId) => catId,
        (_, __, ___, ____, tradingStatus) => tradingStatus,
    ], (state, eventId, marketId, categoryMarketInfoId, tradingStatus) => {
        var _a, _b;
        const probsByEventId = state[eventId];
        const key = (0, outcomes_1.getEventProbabilityByMarketKey)({
            marketId,
            categoryMarketInfoId,
        });
        if (probsByEventId === undefined ||
            ((_a = probsByEventId[key]) === null || _a === void 0 ? void 0 : _a.probabilities) === undefined) {
            return EMPTY_PROBS_ARRAY;
        }
        const outcomes = (_b = probsByEventId[key]) === null || _b === void 0 ? void 0 : _b.probabilities;
        if (tradingStatus) {
            return outcomes.filter((eventProbabilityOutcome) => eventProbabilityOutcome.tradingStatus === tradingStatus);
        }
        else {
            return outcomes;
        }
    });
    return selector;
};
exports.makeSelectEventProbabilityByMarketFiltered = makeSelectEventProbabilityByMarketFiltered;
const makeSelectEventProbabilityByMarketFilteredV3 = () => {
    const selector = (0, toolkit_1.createSelector)([
        exports.selectEventProbabilitiesByVirtualMarketEntries,
        (_, eventId) => eventId,
        (_, __, marketId) => marketId,
        (_, __, ___, catId) => catId,
        (_, __, ___, ____, tradingStatus) => tradingStatus,
    ], (state, eventId, marketId, categoryMarketInfoId, tradingStatus) => {
        var _a, _b;
        const probsByEventId = state[eventId];
        const key = (0, outcomes_1.getEventProbabilityByMarketKey)({
            marketId,
            categoryMarketInfoId,
        });
        if (probsByEventId === undefined ||
            ((_a = probsByEventId[key]) === null || _a === void 0 ? void 0 : _a.probabilities) === undefined) {
            return EMPTY_PROBS_ARRAY;
        }
        const outcomes = (_b = probsByEventId[key]) === null || _b === void 0 ? void 0 : _b.probabilities;
        if (tradingStatus) {
            return outcomes.filter((eventProbabilityOutcome) => eventProbabilityOutcome.tradingStatus === tradingStatus);
        }
        else {
            return outcomes;
        }
    });
    return selector;
};
exports.makeSelectEventProbabilityByMarketFilteredV3 = makeSelectEventProbabilityByMarketFilteredV3;
const makeEventCompetitorsRenameSelector = (eventId) => {
    return (0, toolkit_1.createSelector)([
        (state) => selectEventCompetitorsList(state, eventId),
        (state) => (0, exports.selectEventHomeCompetitorIds)(state, eventId),
        (state) => (0, exports.selectEventTypeCode)(state, eventId),
        (state) => (0, exports.selectEventStatus)(state, eventId),
        (state) => (0, exports.selectEventDate)(state, eventId),
        (state) => (0, selectors_1.selectCompetitorRenameConfig)(state),
    ], (competitors, homeCompetitorIds, eventType, eventStatus, eventDate, { renameDate, isNewSbCompetitorsNameEnabled }) => {
        return (0, events_1.getHomeAwayCompetitorsRenamed)({
            event: {
                competitors,
                homeCompetitorIds,
                eventType,
                status: eventStatus,
                eventDate,
            },
            renameDate,
            isNewSbCompetitorsNameEnabled,
        });
    });
};
exports.makeEventCompetitorsRenameSelector = makeEventCompetitorsRenameSelector;
//# sourceMappingURL=probabilitiesSelectors.js.map